const user = {
  login() {
    return "/account/Login";
  },
  loginMultiFactor() {
    return "/account/Login/multifactor";
  },
  persistLogin() {
    return "/account/persist-login";
  },
  forgotPassword(username) {
    return `/account/forgot-password?username=${username}`;
  },
  resetPassword: () => "/account/reset-password",
  getPasswordDefinitions: () => "/account/password-definitions",
  getProfile() {
    return "/account/profile";
  },
  updateProfile() {
    return "/account/profile";
  },
  changePassword() {
    return "/account/change-password";
  },
  logout() {
    return "/account/Logout";
  },
  loginKeepAlive(){
    return "/account/login/keep-alive";
  },
  dashboard() {
    return "/account/dashboard";
  },

  caseList() {
    return "/account/caselist";
  },

  notifications() {
    return "/account/notifications";
  },

  statistics() {
    return "/account/statistics";
  },

  getMaintenanceSections() {
    return "/account/maintenance";
  },
  getInternetUserList(search) {
    if (!search) {
      return `/users`;
    }
    return `/users?search=${search}`;
  },
  getLoginStatistics(id) {
    return `/users/${id}/login-statistics`;
  },
  getUser(id) {
    return `/users/${id}`;
  },
  disableUser(id) {
    return `/users/${id}/disable`;
  },
  enableUser(id) {
    return `/users/${id}/enable`;
  },
  allCustomers() {
    return `/users/customers`;
  },
  allSurveyTypes() {
    return `/users/survey-types`;
  },
  addCompany(internetUserId) {
    return `/users/${internetUserId}/companies`;
  },
  deleteCompany(internetUserId, customerNumber) {
    return `/users/${internetUserId}/companies/${customerNumber}`;
  },
  addAgency(internetUserId) {
    return `/users/${internetUserId}/agencies`;
  },
  deleteAgency(internetUserId, agencyCode, databaseType) {
    return `/users/${internetUserId}/agencies/${agencyCode}/type/${databaseType}`;
  },
  allRights() {
    return `/users/rights`;
  },
  addRight(internetUserId) {
    return `/users/${internetUserId}/rights`;
  },
  deleteRight(internetUserId, rightName) {
    return `/users/${internetUserId}/rights/${rightName}`;
  },
  rightEnabled(internetUserId, rightName) {
    return `/users/${internetUserId}/rights/${rightName}`;
  },
  allRoles() {
    return `/users/roles`;
  },
  allRoleData() {
    return `/users/role-data`;
  },
  allMajorCompanies() {
    return `/users/major-companies`;
  },
  updateUser(internetUserId) {
    return `/users/${internetUserId}`;
  },
  rolerights() {
    return "/account/role-rights";
  },
  createUser() {
    return `/users`;
  },
  getRoles(internetUserId) {
    return `/users/${internetUserId}/roles`;
  },
  removeRole(internetUserId, roleName) {
    return `/users/${internetUserId}/roles/${roleName}`;
  },
  getTrainingSections() {
    return `/account/training`;
  }
};

export default user;
